import React, { useCallback } from 'react'
import { Button, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { IAreaInitialState } from '../../interfaces/areas'
import type { IArea } from '../../interfaces/areas'
import { useAreasList, useLargeNamesIds } from './AreasBreadcrumb.hooks'
import styles from './AreasBreadcrumb.module.scss'

interface AreasBreadcrumbProps {
  dataSource: IArea[]
  selectedArea: IArea
  onClick: (parentId: number) => void
}

const AreasBreadcrumb: React.FC<AreasBreadcrumbProps> = ({
  dataSource = [],
  selectedArea = IAreaInitialState,
  onClick,
}) => {
  const itemsToShow = useAreasList(selectedArea, dataSource)
  const largeNamesIds = useLargeNamesIds(itemsToShow)
  const hasLargeName = useCallback(
    (id: number) => largeNamesIds.includes(String(id)),
    [largeNamesIds],
  )
  const isFirstItem = useCallback((index: number) => index === 0, [])

  return (
    <div className={`${styles.container} areaSelector-breadcrumb`}>
      {itemsToShow.length > 1 && (
        <Button
          className={styles.backButton}
          onClick={() => {
            onClick(selectedArea.parentId ?? 0)
          }}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </Button>
      )}
      {itemsToShow.map(({ id, name }: IArea, index: number) => (
        <div
          className={`${styles.areas} areaSelector-breadcrumb-item`}
          id={`${id}`}
          key={`breadcrumsItem-${id}`}
          onClick={() => {
            onClick(id)
          }}
        >
          {!isFirstItem(index) && <FontAwesomeIcon icon={faChevronRight} />}
          {hasLargeName(id) ? (
            <Tooltip title={name}>
              <span> {name} </span>
            </Tooltip>
          ) : (
            <span> {name} </span>
          )}
        </div>
      ))}
    </div>
  )
}

export default AreasBreadcrumb
